import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigApiServiceService } from '../providers/config-api-service.service';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SuccessPaymentComponent } from '../success-payment/success-payment/success-payment.component';
import { ToastrService } from 'ngx-toastr';
import { AlertMessageComponent } from '../alert-message/alert-message.component';

declare var Stripe: any;
const defaultValue = 0
const invoiceNumber = '20230000';
@Component({
  selector: 'app-admin-eita-registration',
  templateUrl: './admin-eita-registration.component.html',
  styleUrls: ['./admin-eita-registration.component.css']
})
export class AdminEitaRegistrationComponent implements OnInit {

  @ViewChild('dialogRef', { static: false })
  dialogRef!: TemplateRef<any>
  eita_RegistrationForm: FormGroup;
  event_Id: any;
  event_price: any;
  event_Name: any;
  Registration_Id: any = [];
  currentEvent: any = 'Eita';
  dateFormat = 'yyyy-MM-dd';
  currentDate = new Date();
  showQRCode: boolean;
  private stripe: any;
  StripePaymentUrl: any = 'https://drive.prodcast.cloud:3784/Stripepayment'; // Live_Url
  //StripePaymentUrl: any = 'https://localhost:3784/Stripepayment'; // Local_Url
  sendUrl: any = 'https://drive.prodcast.cloud:3784/sendMail'; // Live_Url
  // sendUrl: any = 'https://localhost:3784/sendMail'; // Local_Url
  adminEmailId: any = "hello@thelovehopecompany.com";
  invoiceNo: any;
  eitaEvent: any;
  selectPayment: any;
  checkPaymentmethod: boolean = false;
  eitaDetails: any;
  showUpiId: boolean = false;
  updateInvoiceNo: number;
  //sendEventSMSUrl: any = 'https://localhost:3784/sendEventSMS'; // Local_Url'
  sendEventSMSUrl: any = 'https://drive.prodcast.cloud:3784/sendEventSMS'; // Live_Url'
  whatsAppLink: any;
  event_Date: any;
  event_Time: any;
  locationMaster: any;
  no_Of_child: any;
  eventPrice: number;
  duplicateName: boolean;
  enableMobileError: boolean;
  showPaymentScreen: boolean = false;
  childName: any = [];
  ccEmailId: any = "admin@thelovehopecompany.com";
  paymentStatus: any = "UnPaid";
  phonePeUrl: any = 'https://drive.prodcast.cloud:3784/phonepeUrl'; // Live_Url
  // phonePeUrl: any = 'https://localhost:3784/phonepeUrl'; // Local_Url
  checkoutUrl: any;
  showForm: boolean;
  eita_Registration_Id: any=[];

  constructor(private http: HttpClient, private router: Router, private fb: FormBuilder, public configApiService: ConfigApiServiceService, public datePipe: DatePipe, public dialog: MatDialog, public toastr: ToastrService) {
    this.stripe = Stripe('pk_live_51NLPLuSBD5puc8V6VxIWY56IOkpKPhAjvYXlnCRGHyfYs9ani4GDozu4ckp8EDgMXlRM1U5d7kkkbnvxEphaKSRN00PX5pFIRa'); //Live Keys
    //this.stripe = Stripe('pk_test_51NLNLISAvZBYHudzm5UsIdpwQQz96O1qlBSF9IIjPG7T93GqpjgJx2sZFeVSkwfP2DghhjfydoA4g7a6VU1N2ySL004IZBsWYw'); //Local Keys
  }

  ngOnInit() {
    this.eita_RegistrationForm = this.fb.group({
      children: this.fb.array([this.createChildFormGroup()]),
      parent_one: ['', [Validators.required]],
      phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      email: ['', [Validators.required, Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)]],
      sourceReferral: ['', [Validators.required]],
      description: ['',],
      additional_Comments: ['',],
    });
    this.getEvents()
    this.getTransaction();
    this.getLocation();
    localStorage.removeItem('CustomerDeatils');
    localStorage.removeItem('eventsDeatils');
    localStorage.removeItem('sessionDeatils');
  }

  /**
  * get Events List
  */
  getEvents() {
    this.configApiService.pullRequest(this.configApiService.lhcApi.pullEvents.params, (respData) => {
      if (respData.length != defaultValue) {
        this.configApiService.EventsList = respData;
        let eitaEvent = this.configApiService.EventsList.filter(item => {
          const eventEndDate = new Date(item.Event_End_Date + 'T23:59:59');
          return item.Event_Type === this.currentEvent &&
            item.Event_Active === "true" &&
            eventEndDate >= this.currentDate;
        });
        if (eitaEvent.length > 0) {
          this.event_Id = eitaEvent[defaultValue].Event_Master_1_Id;
          this.event_price = eitaEvent[defaultValue].Event_Price;
          this.event_Name = eitaEvent[defaultValue].Event_Name;
          this.whatsAppLink = eitaEvent[defaultValue].Whats_App_Link;
          this.event_Date = eitaEvent[defaultValue].Event_Date;
          this.event_Time = eitaEvent[defaultValue].Event_Time;
          this.showForm = true;
        }
        else {
          this.showForm = false;
        }
      }
    })
  }

  /**
  *method for Validate Name
  **/
  validateName() {
    const childrenData = this.eita_RegistrationForm.controls.children.value;
    if (childrenData.length >= 2) {
      const duplicateChildNames = childrenData.filter((child: any, index: number, array: any[]) => {
        const currentName = child['name'].toLowerCase();
        if (currentName != "") {
          return array.findIndex((c: any) => c !== child && c['name'].toLowerCase() === currentName) !== -1;
        }
      });
      const hasDuplicateNames = duplicateChildNames.length > 0;
      if (hasDuplicateNames == true) {
        let message = "Child name cannot be same "
        let title = "Alert"
        this.openAlert(message, title, (result) => {
          if (result) {
          }
        })
        this.duplicateName = true;
      }
      else {
        this.duplicateName = false;
      }
    }
  }


  /**
  * submit Eita Registration
  */
  submit() {
    if (this.eita_RegistrationForm.valid && this.duplicateName != true && this.enableMobileError != true) {
      const childrenData = this.eita_RegistrationForm.controls.children.value;
      console.log(childrenData, "childrenData")
      this.no_Of_child = childrenData.length;
      childrenData.forEach(element => {
        this.childName.push(element.name)
        let postData = {
          "Event_Name": this.event_Name || "",
          "Name": element.name || "",
          "Age": element.age || "",
          "Grade": element.grade || "",
          "School": element.school || "",
          "ParentName_one": this.eita_RegistrationForm.controls.parent_one.value || "",
          "ParentName_two": "",
          "Mobile_no": this.eita_RegistrationForm.controls.phone.value || "",
          "Email": this.eita_RegistrationForm.controls.email.value || "",
          "Referral_eita": this.eita_RegistrationForm.controls.sourceReferral.value || "",
          "Description": this.eita_RegistrationForm.controls.description.value || "",
          "Additional_comments": this.eita_RegistrationForm.controls.additional_Comments.value || "",
          "Event_id": this.event_Id || 0,
          "Event_amount": this.event_price || 0,
          "Mode_of_Payment": "",
          "Payment_Status": this.paymentStatus || "",
        }
        this.eitaDetails = postData;
        let objData = Object.assign({}, this.configApiService.lhcApi.postEitaRegistration.params, postData);
        this.configApiService.pushRequest(objData, this.resGroupSuccess)
      });
    }
    else {
      this.toastr.error('Please Fill All Mandatory Fields', '', {
        positionClass: 'toast-bottom-center',
        timeOut: 3000,
      });
      this.markFormGroupAsTouched(this.eita_RegistrationForm);
    }
  }

  /**
  * Group Therapy Form Submit response
  **/
  resGroupSuccess = ((resData) => {
    if (resData) {
      console.log(resData)
      let Registration_Id = resData['Event_Registration5146'].Event_Registration_Id
      this.Registration_Id.push(Registration_Id)
      console.log(this.Registration_Id, "registrationid")
      if (this.event_price > defaultValue) {
        if (this.no_Of_child == this.Registration_Id.length) {
          this.showPaymentStatus();
        }
      } else {
        this.configApiService.showEitaReg = true;
        this.sendEventSms();
        this.sendMail(this.eitaDetails.Email);
        this.openEitaReg();
      }
    }
  })

  /**
   * Validation for form 
   * @param formGroup 
   */
  markFormGroupAsTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      if (control instanceof FormGroup) {
        this.markFormGroupAsTouched(control);
      } else if (control instanceof FormArray) {
        control.controls.forEach(childGroup => {
          this.markFormGroupAsTouched(childGroup as FormGroup);
        });
      } else {
        control.markAsTouched();
      }
    });
  }

  /**
    * Show payment status screen 
    */
  showPaymentStatus() {
    let message = "Please confirm if ₹ " + this.eventPrice + " the payment is received ?"
    let title = "Event"
    this.openAlert(message, title, (result) => {
      if (result == "yes") {
        if (this.Registration_Id.length > 0) {
          this.Registration_Id.forEach((e: any) => {
            var params = {
              Event_Registration_Id: e
            }
            let objData = Object.assign({}, this.configApiService.lhcApi.pullEitaRegistration.params, params);
            this.configApiService.pullRequest(objData, (respData) => {
              if (respData.length > 0) {
                let postData = {
                  "Event_Registration_Id": respData[0].Event_Registration_Id || 0,
                  "Event_Name": respData[0].Event_Name || "",
                  "Name": respData[0].Name || "",
                  "Age": respData[0].Age || "",
                  "Grade": respData[0].Grade || "",
                  "School": respData[0].School || "",
                  "ParentName_one": respData[0].ParentName_one || "",
                  "ParentName_two": "",
                  "Mobile_no": respData[0].Mobile_no || "",
                  "Email": respData[0].Email || "",
                  "Referral_eita": respData[0].Referral_eita || "",
                  "Description": respData[0].Description || "",
                  "Additional_comments": respData[0].Additional_comments || "",
                  "Event_id": respData[0].Event_id || 0,
                  "Event_amount": respData[0].Event_amount || 0,
                  "Mode_of_Payment": "Cash on Hand",
                  "Payment_Status": "Paid Successfull",
                }
                let objData = Object.assign({}, this.configApiService.lhcApi.postEitaRegistration.params, postData);
                this.configApiService.pushRequest(objData, this.resSuccess)
              }
            })
          })
        }
      }
      else{
        this.router.navigate(["/"])
      }
    })
  }

  resSuccess = ((resData) => {
    if (resData != 'FAIL') {
      console.log(resData)
     this.eita_Registration_Id.push(resData['Event_Registration5146'].Event_Registration_Id)
      if (this.no_Of_child == this.eita_Registration_Id.length) {
        this.updateEitaTransaction();
      }
    }
  })

  /**
    * show payment screen popup
    */
  paymentScreen() {
    this.showQRCode = false;
    this.opendialog();
  }

  /**
  * get Transaction Summary
  */
  getTransaction() {
    this.configApiService.pullRequest(this.configApiService.lhcApi.pushLhc_Invoice.params, (respData) => {
      if (respData.length != defaultValue) {
        if (respData[0].LatestInvoiceNumber) {
          this.invoiceNo = respData[0].LatestInvoiceNumber;
        } else {
          this.invoiceNo = invoiceNumber;
        }
      }
    });
  }

  /***
  * method for openpoup 
  */
  opendialog() {
    this.dialog.open(this.dialogRef, { disableClose: true, })
  }

 
  /***
 * method for closepopup
 */
  close() {
    this.dialog.closeAll()
    this.router.navigate(['/']);
  }


  /**
  * Payment mode events
  */
  enablepayment(e) {
    this.selectPayment = e.target.value;
    this.checkPaymentmethod = true;
  }


  /**
  * Update Eita Transaction
  */
  updateEitaTransaction() {
    this.updateInvoiceNo = parseInt(this.invoiceNo) + 1
    this.eventPrice = this.event_price * this.no_Of_child;
    let clientName = this.eita_RegistrationForm.controls.parent_one.value + "- Child " + this.no_Of_child;

    let postTransaction = {
      "Trans_Ref_id": "",
      "Events_Id": this.eitaDetails.Events_Id || 0,
      "Event_Name": this.eitaDetails.Event_Name || "",
      "Registration_Name": clientName || "",
      "Group_Type": this.currentEvent || "",
      "Registration_Id": this.Registration_Id || 0,
      "Gw_Trans_Ref_id": 0,
      "Gw_trans_Status": 0,
      "Date_of_transacion": this.datePipe.transform(this.currentDate, this.dateFormat),
      "Amount_paid": this.eventPrice || 0,
      "Coupon": "",
      "Modeofpayment": "Cash on Hand",
      "Transaction_Status": "",
      "Invoice_no": this.updateInvoiceNo || "",
    }
    this.configApiService.etiaTransaction = postTransaction;
    let objData = Object.assign({}, this.configApiService.lhcApi.postEventTransaction.params, postTransaction);
    this.configApiService.pushRequest(objData, this.resTransactionSuccess)
  }

  /**
  * comfort Spaces Form Submit response
  */
  resTransactionSuccess = ((resData) => {
    if (resData != 'FAIL') {
      console.log("Success")
      this.configApiService.showEitaUpiSuccess = true;
      this.updateInvoice(this.updateInvoiceNo);
      this.sendEventSms();
      this.sendMail(this.eitaDetails.Email);
      this.openEitaSuccess();
    }
  })

  /***
  * Method for open UPI Payment Registration  success
  */
  openEitaSuccess(): void {
    var params = {
      eita: this.eitaDetails,
      invoiceNo: this.updateInvoiceNo,
    }
    const dialogRef = this.dialog.open(SuccessPaymentComponent, {
      data: { params },
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  /***
  * Method for open Registration  success
  */
  openEitaReg(): void {
    var params = {
      eita: this.eitaDetails,
    }
    const dialogRef = this.dialog.open(SuccessPaymentComponent, {
      data: { params },
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  /**
  * Update Invoice number to master
  */
  updateInvoice(invoice) {
    let invoiceData = {
      LatestInvoiceNumber: invoice,
    }
    let objData = Object.assign({}, this.configApiService.lhcApi.pullLhc_Invoice.params, invoiceData);
    this.configApiService.pushRequest(objData, this.resInovice)
  }

  /**
  * Invoice Response Data
  */
  resInovice = ((resData) => {
    if (resData != 'FAIL') {
      console.log("Invoice Updated")
    }
  })

  /**
  * send mail through mail
  */
  sendMail(mailId) {
    let mailScheduler = {};
    var FROMID = this.adminEmailId;
    var TOID = mailId;
    var CC = this.adminEmailId;
    var BCC = this.ccEmailId
    var location;
    var address;
    if (this.locationMaster[0].Location_Link) {
      location = this.locationMaster[0].Location_Link;
      address = this.locationMaster[0].Address;
    }
    var _mailhtmlbody = "<html><head></head><body><h4>Dear " + this.eitaDetails.ParentName_one + "</h4><p> Thank you for registering for " + this.event_Name + ". Your payment is received and your registration has been confirmed. </p><p>We look forward to seeing " + this.childName + " on,</p><br>Date : " + this.event_Date + " <br>Time : " + this.event_Time + "  <br>Location : <a href='" + location + "'>" + address + "</a> <p>For any further queries, please reach out to us at +91 9677029999</p><div>Warm regards,<br>The Love Hope Company</div><br><br><p>Join our WhatsApp Community for more updates: <br><a href='" + this.whatsAppLink + "'>" + this.whatsAppLink + "</a> </p></body></html>"
    var mailSubject = "Registration Successful- The Love Hope Company!";
    mailScheduler = { 'TOID': TOID, 'FROMID': FROMID, 'CC': CC, "BCC": BCC, 'BODY': _mailhtmlbody, 'ShareType': 1, 'SUBJECT': mailSubject };
    let objPushParams = Object.assign({}, this.configApiService.lhcApi.pushMailShareUser.params, mailScheduler);
    this.configApiService.pushRequest(objPushParams, this.mailSentResponseStatus);
  }

  mailSentResponseStatus = ((responsedata) => {
    if (responsedata == "SUCCESS") {
      console.log(responsedata, "responsedata")
    }
  });

  /**
  * Send Events SMS api
  */
  sendEventSms() {
    var param = {
      TOID: this.eitaDetails.Mobile_no,
      Event_Name: this.eitaDetails.Event_Name,
      Event_Date: this.datePipe.transform(this.currentDate, this.dateFormat),
    };
    var obj = {};
    obj['data'] = JSON.stringify(param);
    var pa = JSON.stringify(obj);
    this.http.post(this.sendEventSMSUrl, pa).subscribe((response: any) => {
      console.log(response, "response")
    })
  }

  /**
   * Submit contact Form
   */
  getLocation() {
    this.configApiService.pullRequest(this.configApiService.lhcApi.pullLocationMaster.params, (respData) => {
      if (respData.length != defaultValue) {
        this.locationMaster = respData;
      }
    });
  }

  /**
  *method for validate customer
  */
  fetchCustomer(e) {
    if (e.target.value) {
      var params = {
        Mobile_no: e.target.value
      }
      let objData = Object.assign({}, this.configApiService.lhcApi.pullEitaCustomer.params, params);
      this.configApiService.pullRequest(objData, (respData) => {
        if (respData.length != defaultValue) {
          let duplicateNumber = respData.filter(e => {
            return e.Event_id == this.event_Id
          })
          if (duplicateNumber.length > 0) {
            this.enableMobileError = true;
            let message = "This Number already Registered"
            let title = "Alert"
            this.openAlert(message, title, (result) => {
              if (result) {
              }
            })
          } else {
            this.enableMobileError = false;
          }
        } else {
          this.enableMobileError = false;
        }
      })
    }
  }

  /***
 * Method for open Registration  success
 */
  openAlert(message, title, callback): void {
    const dialogRef = this.dialog.open(AlertMessageComponent, {
      data: {
        message: message,
        title: title
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      callback(result)
    });
  }

  /**
   * method for create Child FormGroup
   */

  get children() {
    return this.eita_RegistrationForm.get('children') as FormArray;
  }

  /**
    * method for create Child FormGroup
    */
  createChildFormGroup() {
    return this.fb.group({
      name: ['', Validators.required],
      age: ['', Validators.required],
      grade: ['', Validators.required],
      school: ['', Validators.required]
    });
  }

  /**
    * method for add multiple child
    */
  addChild() {
    this.children.push(this.createChildFormGroup());
    const childrenData = this.eita_RegistrationForm.controls.children.value;
    this.no_Of_child = childrenData.length;
    this.eventPrice = this.event_price * this.no_Of_child;
  }

  /**
  * method for Remove child
  */
  removeChild(index: number) {
    this.children.removeAt(index);
    const childrenData = this.eita_RegistrationForm.controls.children.value;
    this.no_Of_child = childrenData.length;
    this.eventPrice = this.event_price * this.no_Of_child;
  }
}



